import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { serviceOverviewItems } from '../../../data/services';

export default function ServicesOverviewSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-white pt-[72px] py-24">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 mb-4 px-3 py-1.5 bg-primary/10 border border-primary/20 rounded-full">
            <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
            <span className="text-primary text-xs font-medium uppercase tracking-widest">
              {t('servicesOverview.tag')}
            </span>
          </div>
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-gray-900 mb-4">
            {t('servicesOverview.title')}
          </h1>
          <p className="text-gray-500 text-base max-w-2xl mx-auto">{t('servicesOverview.desc')}</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {serviceOverviewItems.map((item) => (
            <Link
              key={item.slug}
              to={item.path}
              className="group bg-white border border-primary/15 hover:border-primary/35 rounded-2xl overflow-hidden transition-all duration-300 cursor-pointer block"
            >
              <div className="relative w-full h-[220px] overflow-hidden">
                <img
                  src={item.image}
                  alt={t(item.labelKey)}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-white via-white/10 to-transparent" />
                <div className="absolute top-4 left-4 flex items-center gap-2 px-3 py-1.5 bg-white/90 border border-primary/20 rounded-lg backdrop-blur-sm">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className={`${item.icon} text-sm text-primary`} />
                  </div>
                  <span className="text-gray-800 text-xs font-medium">{t(item.labelKey)}</span>
                </div>
              </div>

              <div className="p-6">
                <p className="text-gray-500 text-sm leading-relaxed mb-4">{t(item.descKey)}</p>
                <div className="flex flex-wrap gap-2 mb-5">
                  {item.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2.5 py-1 bg-pink-50 border border-primary/15 text-xs text-gray-500 rounded-md"
                    >
                      {t(tag)}
                    </span>
                  ))}
                </div>
                <div className="flex items-center gap-2 text-sm font-medium group-hover:gap-3 transition-all duration-200 text-primary">
                  {t('servicesOverview.cta')}
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line" />
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
